module.exports = __webpack_public_path__ + "img/Case_6.5e3a14d1.jpg";